import React, { useState } from "react";

import {
  Route,
  Routes,
  Navigate,
  BrowserRouter as Router,
} from "react-router-dom";

import { Layout } from 'antd';

import SideNav from "../components/SideNav";
import HeaderNav from "../components/Header";
import Login from "./Login";

// ADMIN
import Voters from "./Admin/Voters";
import ViewVoter from "./Admin/Voters/ViewVoter";

import TeamLeaders from "./Admin/TeamLeaders";
import AddTeamLeader from "./Admin/TeamLeaders/AddTeamLeader";
import ViewTeamLeader from "./Admin/TeamLeaders/ViewTeamLeader";
import TopUpTeamLeaders from "./Admin/TeamLeaders/TopUpTeamLeaders";

import Events from "./Admin/Events";
import ViewEvent from "./Admin/Events/ViewEvent";
import AddEvent from "./Admin/Events/AddEvent";
import AddCustomEvent from "./Admin/Events/AddCustomEvent";
import AddEventAyuda from "./Admin/Events/ViewEvent/AddEventAyuda";
import AddEventItem from "./Admin/Events/ViewEvent/AddEventItem";

import Admins from "./Admin/Admins";
import AddAdmin from "./Admin/Admins/AddAdmin";
import ViewAdmin from "./Admin/Admins/ViewAdmin";
import CustomEvents from "./Admin/Events/CustomEvent";

import AuditTrails from "./Admin/Reports/AuditTrails";

// TEAMLEADERS
import TLVoters from "./TeamLeader/Voters";
import TLViewVoter from "./TeamLeader/Voters/ViewVoter";

import TLEvents from "./TeamLeader/Events";
import TLAddEvent from "./TeamLeader/Events/AddEvent";
import TLViewEvent from "./TeamLeader/Events/ViewEvent";
import TLEventRegistration from "./TeamLeader/Events/ViewEvent/EventRegistration";
import TLAddEventAyuda from "./TeamLeader/Events/ViewEvent/AddEventAyuda";
import TLAddEventItem from "./TeamLeader/Events/ViewEvent/AddEventItem";
import OrganizationMembers from "./Admin/Organization/OrganizationMembers";
import OrganizationInvites from "./Admin/Organization/OrganizationInvites";
import TeamLeaderOrganization from "./TeamLeader/TeamLeaderOrganization";
import AddTeamLeaderInvite from "./TeamLeader/TeamLeaderOrganization/AddTeamLeaderInvite";
import CoreLeaderOrganization from "./CoreLeader/CoreLeaderOrganization";
import AddCoreLeaderInvite from "./CoreLeader/CoreLeaderOrganization/AddCoreLeaderInvite";
import ZoneLeaderOrganization from "./ZoneLeader/ZoneLeaderOrganization";
import AddZoneLeaderInvite from "./ZoneLeader/ZoneLeaderOrganization/AddZoneLeaderInvite";
import AddMockVoting from "./Admin/TeamLeaders/MockVoting/AddMockVoting";
import TeamLeadersMemberReport from "./Admin/Reports/TeamLeadersReport/TeamLeadersMemberReport";
import TeamLeadersInvitesReport from "./Admin/Reports/TeamLeadersReport/TeamLeadersInvitesReport";
import ViewLeaderReport from "./Admin/Reports/TeamLeadersReport/ViewLeaderReport";

export default function Pages() {
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 767 ? true : false);
  const user = JSON.parse(localStorage.getItem("dXNlclN0b3Jl"));
  const userType = user ? user.userType : "";
  const usermetadata = user ? user.metadata : "";

  // FOR DEFAULT METADATA VALUES
  const defaultpermissions = {
    hasAddClusterLeader: false,
    hasfundAllocation: false,
    hasEvents: false,
    hasOrganizations: false
  };
  const defaultstring = JSON.stringify(defaultpermissions);
  const defaultmetadata = btoa(defaultstring);
  const metadata = usermetadata ? usermetadata : defaultmetadata;

  const decodedString = decodeURIComponent(escape(atob(metadata)));
  const permissions = JSON.parse(decodedString);

  console.log(permissions)

  return (
    <Router>
      {
        userType === "" ? (
        <>
          <Routes path>
            <Route path={"/"} element={<Login/>} />
            <Route path={"/login"} element={<Login/>} />
            <Route path="*" element={<Navigate to="/" replace />}/>
          </Routes>
        </>
      ) : userType === "SUPERADMIN" ? (
        <>
          <Layout>
            <SideNav collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Layout>
              <HeaderNav collapsed={collapsed} setCollapsed={setCollapsed}/>
              <Layout style={(!collapsed && window.innerWidth <= 767) ? { visibility:  'hidden', height: "100vh"} : {visibility: 'visible', margin: 0}}>
                <Routes>

                  <Route path={"/admins"} element={<Admins/>} />
                  <Route path={"/admins/add"} element={<AddAdmin/>} />
                  <Route path={"/admins/:id"} element={<ViewAdmin/>} />
                  
                  <Route path={"/team-leaders"} element={<TeamLeaders/>} />
                  <Route path={"/team-leaders/add"} element={<AddTeamLeader/>} />
                  <Route path={"/team-leaders/top-up"} element={<TopUpTeamLeaders/>} />
                  <Route path={"/team-leaders/:id"} element={<ViewTeamLeader/>} />

                  <Route path={"/organization"} element={<OrganizationMembers/>} />
                  <Route path={"/organization-invites/:pReferrerID/:pUserType"} element={<OrganizationInvites/>} />

                  <Route path={"/voters"} element={<Voters/>} />
                  <Route path={"/voters/:id"} element={<ViewVoter/>} />
                  
                  <Route path={"/events"} element={<Events/>} />
                  <Route path={"/events/add"} element={<AddEvent/>} />
                  <Route path={"/events/addcustom"} element={<AddCustomEvent/>} />
                  <Route path={"/events/custom"} element={<CustomEvents/>} />
                  <Route path={"/events/:id"} element={<ViewEvent/>} />
                  <Route path={"/events/:id/add"} element={<AddEventAyuda/>} />
                  <Route path={"/events/:id/additem"} element={<AddEventItem/>} />

                  <Route path={"audittrails"} element={<AuditTrails/>} />
                  <Route path={"/teamleaderreports"} element={<TeamLeadersMemberReport/>} />
                  <Route path={"/teamleaderreports/invites/:pReferrerID/:pUserType"} element={<TeamLeadersInvitesReport/>} />
                  <Route path={"/teamleaderreports/:id"} element={<ViewLeaderReport/>} />

                  <Route path="*" element={<Navigate to="/team-leaders" replace />}/>
                </Routes>
              </Layout>
            </Layout>
          </Layout>
        </>
      ) : userType === "ADMIN" ? (
        <>
          <Layout>
            <SideNav collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Layout>
              <HeaderNav collapsed={collapsed} setCollapsed={setCollapsed}/>
              <Layout style={(!collapsed && window.innerWidth <= 767) ? { visibility:  'hidden', height: "100vh"} : {visibility: 'visible', margin: 0}}>
                <Routes>
              
                  <Route path={"/team-leaders"} element={<TeamLeaders/>} />
                  <Route path={"/team-leaders/:id"} element={<ViewTeamLeader/>} />
                  { permissions.hasAddClusterLeader === "true" ? <Route path={"/team-leaders/add"} element={<AddTeamLeader/>} /> : null }
                  { permissions.hasfundAllocation === "true" ? <Route path={"/team-leaders/top-up"} element={<TopUpTeamLeaders/>} /> : null }

                  <Route path={"/voters"} element={<Voters/>} />
                  <Route path={"/voters/:id"} element={<ViewVoter/>} />

                  { permissions.hasOrganizations === "true" ? (
                    <>
                      <Route path={"/organization"} element={<OrganizationMembers/>} />
                      <Route path={"/organization-invites/:pReferrerID/:pUserType"} element={<OrganizationInvites/>} />
                    </>
                  ) : null }
                  { permissions.hasEvents === "true" ? (
                    <>
                      <Route path={"/events/custom"} element={<CustomEvents/>} />
                      <Route path={"/events/addcustom"} element={<AddCustomEvent/>} />
                      <Route path={"/events/:id"} element={<ViewEvent/>} />
                      <Route path={"/events/:id/add"} element={<AddEventAyuda/>} />
                      <Route path={"/events/:id/additem"} element={<AddEventItem/>} />
                    </>
                  ) : null }

                  <Route path="*" element={<Navigate to="/team-leaders" replace />}/>
                </Routes>
              </Layout>
            </Layout>
          </Layout>
        </>
      ) : userType === "TEAM_LEADER" ? (
        <>
          <Layout>
            <SideNav collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Layout>
              <HeaderNav collapsed={collapsed} setCollapsed={setCollapsed}/>
              <Layout style={(!collapsed && window.innerWidth <= 767) ? { visibility:  'hidden', height: "100vh"} : {visibility: 'visible', margin: 0}}>
                <Routes>

                  <Route path={"/voters"} element={<TLVoters/>} />
                  <Route path={"/voters/:id"} element={<TLViewVoter/>} />

                  <Route path={"/organization"} element={<TeamLeaderOrganization/>} />
                  <Route path={"/organization/add-invite"} element={<AddTeamLeaderInvite/>} />

                  <Route path={"/mock-voting"} element={<AddMockVoting/>} />

                  <Route path={"/events"} element={<TLEvents/>} />
                  <Route path={"/events/:id"} element={<TLViewEvent/>} />
                  <Route path={"/events/:id/eventregistration"} element={<TLEventRegistration/>} />

                  {/* <Route path={"/events/add"} element={<TLAddEvent/>} /> */}
                  {/* <Route path={"/events/:id/add"} element={<TLAddEventAyuda/>} />
                  <Route path={"/events/:id/additem"} element={<TLAddEventItem/>} /> */}

                  <Route path="*" element={<Navigate to="/voters" replace />}/>
                </Routes>
              </Layout>
            </Layout>
          </Layout>
        </>
      ) : userType === "CORE_LEADER" ? (
        <>
          <Layout>
            <SideNav collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Layout>
              <HeaderNav collapsed={collapsed} setCollapsed={setCollapsed}/>
              <Layout style={(!collapsed && window.innerWidth <= 767) ? { visibility:  'hidden', height: "100vh"} : {visibility: 'visible', margin: 0}}>
                <Routes>
                  <Route path={"/organization"} element={<CoreLeaderOrganization/>} />
                  <Route path={"/organization/add-invite"} element={<AddCoreLeaderInvite/>} />
                  <Route path="*" element={<Navigate to="/organization" replace />}/>
                </Routes>
              </Layout>
            </Layout>
          </Layout>
        </>
      ) : (
        <>
          <Layout>
            <SideNav collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Layout>
              <HeaderNav collapsed={collapsed} setCollapsed={setCollapsed}/>
              <Layout style={(!collapsed && window.innerWidth <= 767) ? { visibility:  'hidden', height: "100vh"} : {visibility: 'visible', margin: 0}}>
                <Routes>
                  <Route path={"/organization"} element={<ZoneLeaderOrganization/>} />
                  <Route path={"/organization/add-invite"} element={<AddZoneLeaderInvite/>} />
                  <Route path="*" element={<Navigate to="/organization" replace />}/>
                </Routes>
              </Layout>
            </Layout>
          </Layout>
        </>
      )
      }
    </Router>
  );
}
